import React from "react";
import { NewBookkeepingInfo } from "./model";
import { EditSectionTemplate } from "components/MainSectionTemplate/EditSectionTemplate";
import { routes } from "utilities/routing/generatedRoutes";
import CompanyModalPicker from "components/Picker/CompanyPicker/CompanyModalPicker";
import { BookkeepingCodeInput } from "components/ValidatedFields/BookkeepingCodeInput";

export const BookkeepingNewSection = () => {
  const [value, setValue] = React.useState<NewBookkeepingInfo>({
    company: null,
    code: "",
  });

  const onChange = (newData: Partial<NewBookkeepingInfo>) => {
    setValue({ ...value, ...newData });
  };

  const submit = () => {
    const instruction: server.dto.CreateBookkeepingInstruction = {
      code: value.code,
      companyId: value.company.companyId,
    };
    return window.CoreApi.Bookkeeping.Create(instruction);
  };

  return <EditSectionTemplate
    submit={submit}
    redirectUrl={(itemId) => routes.bookkeeping_Detail(itemId).absolute}
    sections={[{
      key: "bookkeeping",
      type: "regular",
      supportArticleId: serverReference.supportArticleIds.newBookkeeping,
      title: RESX.Bookkeeping.resxBookkeeping,
      fields: [{
        key: "company",
        label: RESX.Company.resxCompany,
        renderEditNew: () => <div className="main-section-template-fields-padding">
          <CompanyModalPicker
            value={value.company}
            onChange={v => onChange({ company: v })}
            modalTitle={RESX.Company.resxCompany}
            addressType="administrative"
            validatorKey="company"
            required={true}
            canCreateNew={false}
          />
        </div>,
      }, {
        key: "code",
        label: RESX.Bookkeeping.Code,
        supportArticleId: serverReference.supportArticleIds.bookkeepingCode,
        renderEditNew: () => <BookkeepingCodeInput
          validatorKey="code"
          focusOnMount
          value={value.code}
          onChange={(code) => { onChange({ code }); }}
        />
      }]
    }]}
  />
}